import { getDateRangeArray, getDateFromUnix, trimDecimals, averageNumberArrayFast, medianNumberArrayFast } from '@einhaus/meteoric-helpers';
export const calculateRiskCapitalStats = (tradeSummaries) => {
    // Create maps to track risk capital and profit per day
    const tradesByDate = new Map();
    const profitByDate = new Map();
    // Pre-process trades to calculate risk capital and profit for each date
    for (const trade of tradeSummaries) {
        const tradeStartDate = getDateFromUnix(trade.start);
        const tradeEndDate = getDateFromUnix(trade.end);
        const tradeDateRange = getDateRangeArray(tradeStartDate, tradeEndDate);
        const numDays = tradeDateRange.length || 1;
        const profitPerDay = trade.profit / numDays;
        for (const date of tradeDateRange) {
            const currentRiskCapital = tradesByDate.get(date) ?? 0;
            tradesByDate.set(date, currentRiskCapital + trade.riskCapital);
            const currentProfit = profitByDate.get(date) ?? 0;
            profitByDate.set(date, currentProfit + profitPerDay);
        }
    }
    // Build arrays for dates with non-zero risk capital
    const riskCapitalValues = [];
    const dailyReturnPercents = [];
    for (const [date, riskCapital] of tradesByDate.entries()) {
        if (!riskCapital)
            continue;
        riskCapitalValues.push(riskCapital);
        const dailyProfit = profitByDate.get(date) ?? 0;
        const dailyReturnPct = (dailyProfit / riskCapital) * 100;
        dailyReturnPercents.push(dailyReturnPct);
    }
    if (!riskCapitalValues.length || !dailyReturnPercents.length) {
        return {
            averageProfitPerDay: 0,
            averageRiskCapitalPerDay: 0,
            returnOnRiskCapital: 0,
            avgProfitPerDayPercent: 0,
            medianProfitPerDayPercent: 0
        };
    }
    const averageRiskCapitalPerDay = trimDecimals(averageNumberArrayFast(riskCapitalValues));
    const totalProfit = tradeSummaries.reduce((acc, trade) => acc + trade.profit, 0);
    const averageProfitPerDay = totalProfit / riskCapitalValues.length;
    const DAYS_IN_YEAR = 365;
    const returnOnRiskCapital = trimDecimals(((averageProfitPerDay * DAYS_IN_YEAR) / averageRiskCapitalPerDay) * 100);
    const avgProfitPerDayPercent = (averageProfitPerDay / averageRiskCapitalPerDay) * 100;
    const medianProfitPerDayPercent = medianNumberArrayFast(dailyReturnPercents);
    return {
        averageProfitPerDay,
        averageRiskCapitalPerDay,
        returnOnRiskCapital,
        avgProfitPerDayPercent,
        medianProfitPerDayPercent
    };
};
//# sourceMappingURL=calculateRiskCapitalStats.js.map